import { supabase } from '@/integrations/supabase/client';
import { getOwnerToken } from './blogOwner';

export type ReactionKind = 'like' | 'bookmark';

export async function getReactionState(postId: string) {
  const token = getOwnerToken();
  const [counts, mine] = await Promise.all([
    supabase
      .from('blog_reactions')
      .select('kind', { count: 'exact', head: false })
      .eq('post_id', postId),
    supabase
      .from('blog_reactions')
      .select('kind')
      .eq('post_id', postId)
      .eq('owner_token', token),
  ]);
  const likeCount = (counts.data || []).filter((r: any) => r.kind === 'like').length;
  const bookmarkCount = (counts.data || []).filter((r: any) => r.kind === 'bookmark').length;
  const liked = (mine.data || []).some((r: any) => r.kind === 'like');
  const bookmarked = (mine.data || []).some((r: any) => r.kind === 'bookmark');
  return { likeCount, bookmarkCount, liked, bookmarked };
}

export async function toggleReaction(postId: string, kind: ReactionKind, on: boolean) {
  const owner_token = getOwnerToken();
  if (on) {
    const { error } = await supabase
      .from('blog_reactions')
      .insert({ post_id: postId, kind, owner_token });
    if (error && !`${error.message}`.includes('duplicate')) throw error;
  } else {
    const { error } = await supabase
      .from('blog_reactions')
      .delete()
      .eq('post_id', postId)
      .eq('kind', kind)
      .eq('owner_token', owner_token);
    if (error) throw error;
  }
}
